var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-picture-virtual-watch"},[(_vm.picture)?_c('div',{staticClass:"avatar-picture",style:(_vm.style)}):_vm._e(),_vm._v(" "),_c('shape',{staticClass:"avatar-mask",class:{ visible: _vm.picture },attrs:{"src":"/static/svg/watch/watch.svg"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02becd9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatars/AvatarPictureVirtualWatch.vue
// module id = null
// module chunks = 